// extracted by mini-css-extract-plugin
var _1 = "styles-module__authenticatedSpacing___x4orT";
var _2 = "styles-module__trailRiverPadding___J6AKc";
export { _1 as "authenticatedSpacing", _2 as "trailRiverPadding" }
